/**
 * Базовый URL API.
 * - Если задан REACT_APP_API_URL при сборке — используется он.
 * - Иначе в браузере: тот же хост, что у SPA + /api (типичный IIS: сайт отдаёт и фронт, и API).
 * - Иначе (тесты): localhost для разработки.
 */
export function getApiBaseUrl() {
    const env = process.env.REACT_APP_API_URL;
    if (env != null && String(env).trim() !== '') {
        return String(env).replace(/\/$/, '');
    }
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
        const o = window.location.origin;
        // Локально: React на :3000, API Kestrel на :5280 (см. launchSettings.json)
        if (o.includes('localhost:3000') || o.includes('127.0.0.1:3000')) {
            return 'http://localhost:5280/api';
        }
        return `${o}/api`;
    }
    return 'http://localhost:5280/api';
}

/** Origin веб-приложения (SPA), без /api — для ссылок на /pricing и т.п. */
export function getWebOrigin() {
    return getApiOrigin();
}

/** Origin сервера API (для статики / видео), без пути /api */
export function getApiOrigin() {
    const base = getApiBaseUrl();
    try {
        return new URL(base).origin;
    } catch {
        return typeof window !== 'undefined' ? window.location.origin : '';
    }
}
